export class WidgetService {
  public readonly enabled: boolean
  private $widgetStore: any

  constructor(enabled: boolean, widgetStore: any) {
    this.enabled = enabled
    this.$widgetStore = widgetStore
  }

  getApiKey(): string | undefined {
    return this.$widgetStore.getApiKey()
  }
}
